import React, { useState, useEffect } from "react";
import OtpSection from "./OtpSection";
import api from '../../../src/api_interceptor/api';
import Loader from "../../components/loader/Loader";


const Login = () => {
    const [showOtp, setShowOtp] = useState(false);
    const [email, setEmail] = useState([]);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [appVersion, setAppVersion] = useState("");

  const validateEmail = (email) => {
    // return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      return /^(?!.*\.\.)[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  };


  useEffect(() => {
    api.post("api/GetCurrentVersion", {
      Product: "CMS",
      Application: "CMS Web",
    })
      .then((response) => {
        if (response.data?.StatusCode === 1 && response.data?.Data?.Version) {
          setAppVersion(response.data.Data.Version);
        }
      })
      .catch(() => {
        // Keep login usable even if version lookup fails.
      });
  }, []);

  const handleGenerateOtp = () => {
    if (!email || email.length === 0) {
      setError("Email is required");
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setError("");
    GenerateOtp();
  };


    const GenerateOtp = () => {
        setIsLoading(true)
        const API_URL = 'api/generate-otp';

        const req_body = {
            EmailId: email,
        };
        api.post(API_URL, req_body, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                if (response.data && response.data.StatusCode === 1) {
                      setShowOtp(true);
                } else if (response.data.StatusCode === 2) {
                      setError(response.data.Message || "Invalid request");
                } else if (response.data.StatusCode === 0) {
                      setError("The email address you entered is invalid");
                } else {
                      setError(response.data?.Message || "Unable to send OTP. Please try again.");
                }
                
                setIsLoading(false)

            })
            .catch((error) => {
                setIsLoading(false)
                console.error("OTP API error:", error);
                if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
                    setError("Unable to connect to server. Please check your internet connection or contact support.");
                } else if (error.response) {
                    // Server responded with error status
                    setError("Server error. Please try again later.");
                } else {
                    setError("An error occurred. Please try again.");
                }
            });
    }

  return (
<>
          {isLoading && <Loader />}

    <div className="h-screen flex overflow-hidden">
<div className="hidden md:block md:w-1/2 lg:w-2/3 auth-left relative">
  {/* <div className="absolute bottom-12 left-12 text-white">
    <h1 className="text-5xl font-bold leading-[1.2]">
      Hello <br /> Welcome
    </h1>
  </div> */}
</div>





      <div className="w-full md:w-1/2 lg:w-1/3 auth-right relative flex justify-center">
          <div className="flex-1 overflow-auto flex justify-center pt-6">

        <div className="login-card">
          <h1 className="text-4xl font-bold mb-3">CMS</h1>

          <div className="bg-white rounded-lg shadow-md px-6 pt-4 pb-6">
            <h2 className="text-xl font-semibold">SuperAdmin Login</h2>
            <p className="text-sm login-desc-clr mb-3">
              Authentication Required
            </p>

            {!showOtp && (
              <>
                <div className="mb-4">
                  <label className="block text-sm font-medium mb-1">
                    Email Id <span className="text-error">*</span>
                  </label>
                  <input
                    type="email"
                    maxLength={100}
                    placeholder="Enter Email"
                    className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                        error ? "input-error" : ""
                      }`}
                    value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError("");
                  }}
                  />

                    {error && ( 
                      <p className="text-red-500 text-xs mt-1">{error}</p>
                    )}
                </div>

                <button
                  className="btn-primary"
                  onClick={() => handleGenerateOtp()}
                >
                  Generate OTP
                </button>
              </>
            )}

          {showOtp && (
              <>
                <OtpSection
                  email={email}
                  onChangeEmail={() => setShowOtp(false)}
                />

              </>
            )}
          </div>
        </div>

</div>
        {appVersion && (
          <div className="absolute bottom-3 right-4 text-[11px] text-slate-500">
            {appVersion}
          </div>
        )}
      </div>
    </div>
  </>

  );
};

export default Login;
